import _ from 'underscore';
import type { ContextProcessorOptions, InstrumentationLog, PageContext } from '../types';

export class ContextProcessor {
  pageContext: PageContext;
  constructor(options: ContextProcessorOptions) {
    this.pageContext = _.defaults(options.pageContext || {}, {
      CurrentCustomer: { Id: -1 },
      CurrentAccount: { Id: -1 },
      CurrentUser: {
        Id: -1, Locale: '', Market: '', UserRole: '', ManagedBy: '', LocaleID: '',
      },
    });
  }

  get CustomerId() {
    return _.result(this.pageContext.CurrentCustomer, 'Id', -1);
  }

  get AccountId() {
    return _.result(this.pageContext.CurrentAccount, 'Id', -1);
  }

  get UserId() {
    return _.result(this.pageContext.CurrentUser, 'Id', -1);
  }

  get Lcid() {
    return _.result(this.pageContext.CurrentUser, 'Locale', _.result(this.pageContext.CurrentUser, 'LocaleID', ''));
  }

  get CustomerMarket() {
    return _.result(this.pageContext.CurrentUser, 'Market', '');
  }

  get UserRole() {
    const role = (this.pageContext &&
      this.pageContext.Permissions &&
      this.pageContext.Permissions.IsInternalUser) ? '(Internal)' : '';
    const userRole = _.result(this.pageContext.CurrentUser, 'UserRole', '');
    return `${userRole}${role}`;
  }

  get CustomerManagedBy() {
    return _.result(this.pageContext.CurrentUser, 'ManagedBy', '');
  }

  get SessionId() {
    return (this.pageContext.Omniture || {}).SessionId || '';
  }

  get PageTrackingId() {
    return this.pageContext.PageTrackingId;
  }

  get PageVersion() {
    return this.pageContext.Version;
  }

  get Pilots() {
    return 'grid';
  }

  get IsAksService() {
    return this.pageContext.IsAksService;
  }

  get IsNetCoreService() {
    return this.pageContext.IsNetCoreService;
  }

  get IsFlightBuildServed() {
    // Serve-scoped signal: the server sets this true ONLY when it actually served the flight (rspack) build
    // for the resolved locale (see AdsAppUI RootPageController / PageSettingsContainer). The PFlags
    // `FlightBuild:true` segment is driven solely off this — it marks requests that were genuinely served
    // the rspack bundle, independent of the user-scoped FlightBuildEnabled pilot permission (which is
    // stamped on every app a flighted user opens, even webpack-only apps like PMax Lite landing). Requires
    // the companion AdsAppUI server change to be deployed.
    return !!this.pageContext.IsFlightBuildServed;
  }

  get IsSSRHydration() {
    return this.pageContext.IsSSRHydration;
  }

  process(rawLogs: InstrumentationLog) {
    return _.extend(rawLogs, {
      customerId: this.CustomerId,
      accountId: this.AccountId,
      userId: this.UserId,
      lcid: this.Lcid,
      sessionId: this.SessionId,
      pageTrackingId: this.PageTrackingId,
      pageVersion: this.PageVersion,
      market: this.CustomerMarket,
      userRole: this.UserRole,
      managedBy: this.CustomerManagedBy,
      pilots: this.Pilots,
      IsAksService: this.IsAksService,
      IsNetCoreService: this.IsNetCoreService,
      IsFlightBuildServed: this.IsFlightBuildServed,
      IsSSRHydration: this.IsSSRHydration,
    });
  }
}
